import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface MenuItem {
  title: string;
  url: string;
  children?: MenuItem[];
  onClick?: (e: React.MouseEvent) => void;
}
const urlsWithNewBadge = ['/EDMNetworkFastWire.html', '/SeibuWireEDM.html', '/EDMNetwork.html'];
export function HeaderDesktopMenu() {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const handleMouseEnter = (dropdown: string) => setOpenDropdown(dropdown);
  const handleMouseLeave = () => setOpenDropdown(null);
  const desktopMenuItems: MenuItem[] = [{
    title: 'Home',
    url: '/'
  }, {
    title: 'About',
    url: '',
    children: [{
      title: 'About Peak',
      url: '/AboutPeakMachineSales.html'
    }, {
      title: 'FAQ',
      url: '/FrequentlyAskedQuestions.html'
    }, {
      title: 'Industry News',
      url: '/ManufacturingIndustryNews.html'
    }]
  }, {
    title: 'Products',
    url: '',
    children: [{
      title: 'Product Lines',
      url: '',
      children: [{
        title: 'Used Machine Inventory',
        url: '/59m7/used-machines.html'
      }, {
        title: 'Fast Wire EDM – Moly Wire',
        url: '/EDMNetworkFastWire.html'
      }, {
        title: 'Seibu America',
        url: '/SeibuWireEDM.html'
      }, {
        title: 'EDM Network',
        url: '/EDMNetwork.html'
      }, {
        title: 'Spinner Milling & Turning',
        url: '/SpinnerMachineTools.html'
      }, {
        title: 'Breton Machine Tools',
        url: '/BretonMachineTools.html'
      }, {
        title: 'Bodor Laser Cutting',
        url: '/BodorLaserCutting.html'
      }]
    }, {
      title: 'Categories',
      url: '',
      children: [{
        title: 'Used Machines',
        url: '/59m7/used-machines.html',
        children: [{
          title: 'Used CNC Machining Centers',
          url: '/59m7/used-machines/used-cnc-machining-centers.html'
        }, {
          title: 'Used EDM Machines',
          url: '/59m7/used-machines/used-edm-machines.html'
        }, {
          title: 'Used Chillers & Transformers',
          url: '/59m7/used-machines/used-chillers-transformers.html'
        }]
      }, {
        title: 'EDM',
        url: '/59m7/edm.html',
        children: [{
          title: 'Wire EDM',
          url: '/59m7/edm.html'
        }, {
          title: 'Sinker EDM',
          url: '/59m7/edm.html'
        }, {
          title: 'Driller EDM',
          url: '/59m7/edm.html'
        }]
      }, {
        title: 'CNC Milling',
        url: '/SpinnerMachineTools.html',
        children: [{
          title: '3 & 4-Axis',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'CNC Bridge Mill',
          url: '/ContactPeakMachineSales.html'
        }, {
          title: '5-Axis',
          url: '/SpinnerMachineTools.html'
        }, {
          title: '5-Axis Gantry',
          url: '/BretonMachineTools.html'
        }]
      }, {
        title: 'CNC Turning',
        url: '/SpinnerMachineTools.html',
        children: [{
          title: 'Ultra-Precision Turning',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'Universal Turning',
          url: '/SpinnerMachineTools.html'
        }, {
          title: 'Multi-Turret',
          url: '/SpinnerMachineTools.html'
        }]
      }, {
        title: 'Laser Cutting',
        url: '/59m7/laser.html',
        children: [{
          title: 'Laser Plate Cutting',
          url: '/BodorLaserCutting.html'
        }, {
          title: 'Laser Tube Cutting',
          url: '/BodorLaserCutting.html'
        }]
      }, {
        title: 'Automation',
        url: '/59m7/automation.html'
      }, {
        title: 'EDM Parts & Consumables',
        url: '/QuoteEDMConsumables.html'
      }]
    }]
  }, {
    title: 'Contact',
    url: '',
    children: [{
      title: 'Contact Us',
      url: '/ContactPeakMachineSales.html'
    }, {
      title: 'Selling Used EDM',
      url: '/SellingUsedEDM.html'
    }]
  }];
  const renderBadge = (url: string) => urlsWithNewBadge.includes(url) ? <span className="text-xs bg-orange text-white px-2 py-0.5 rounded ml-1" data-id="element-2678">
        NEW
      </span> : null;
  return <nav className="hidden lg:flex items-center space-x-6" data-id="element-2679">
      {desktopMenuItems.map(item => {
      if (!item.children || item.children.length === 0) {
        return <a key={item.title} href={item.url} className="text-navy hover:text-orange transition-colors font-medium" data-id="element-2680">
              {item.title}
            </a>;
      }
      const dropdownKey = item.title.toLowerCase();
      const isMegaMenu = item.children.some(child => child.children && child.children.length > 0);
      return <div key={item.title} className="relative" onMouseEnter={() => handleMouseEnter(dropdownKey)} onMouseLeave={handleMouseLeave} data-id="element-2681">
            <button className="flex items-center text-navy hover:text-orange transition-colors font-medium" data-id="element-2682">
              {item.title}
              <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-2683" />
            </button>

            {openDropdown === dropdownKey && <>
                {isMegaMenu ? <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 w-[600px]" data-id="element-2684">
                    <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-6" data-id="element-2685">
                      <div className="grid grid-cols-2 gap-8" data-id="element-2686">
                        {item.children.map(column => <div key={column.title} data-id="element-2687">
                            <h3 className="text-sm font-bold text-navy uppercase mb-3" data-id="element-2688">
                              {column.title}
                            </h3>
                            <div className="space-y-2" data-id="element-2689">
                              {column.children?.map(child => child.children && child.children.length > 0 ? <div key={child.title} data-id="element-2690">
                                    <a href={child.url} className="block text-navy hover:text-orange transition-colors text-sm font-medium" data-id="element-2691">
                                      {child.title}
                                    </a>
                                    <div className="ml-4 mt-1 space-y-1" data-id="element-2692">
                                      {child.children.map(leaf => <a key={leaf.title} href={leaf.url} className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-2693">
                                          {leaf.title}
                                        </a>)}
                                    </div>
                                  </div> : <a key={child.title} href={child.url} onClick={child.onClick} className={`block text-navy hover:text-orange transition-colors text-sm ${urlsWithNewBadge.includes(child.url) ? 'font-medium' : ''}`} data-id="element-2694">
                                    {child.title} {renderBadge(child.url)}
                                  </a>)}
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div> : <div className={`absolute top-full ${dropdownKey === 'contact' ? 'right-0' : 'left-0'} pt-2 w-56`} data-id="element-2695">
                    <div className="bg-white rounded-lg shadow-xl border border-gray-200 py-2" data-id="element-2696">
                      {item.children.map(child => <a key={child.title} href={child.url} className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-2697">
                          {child.title}
                        </a>)}
                    </div>
                  </div>}
              </>}
          </div>;
    })}
    </nav>;
}